(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
	this.headerBounds = {};
	this.currentScrollTop = 0;
	this.preventReveal = false;

	if (this.headerIsAlwaysSticky) {
	this.header.classList.add('shopify-section-header-sticky');
	this.header.classList.add('always-fixed');
	};

	this.onScrollHandler = this.onScroll.bind(this);
	this.hideHeaderOnScrollUp = () => this.preventReveal = true;
	this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
	}

	disconnectedCallback() {
	this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
	});

	observer.observe(this.header);
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (this.preventHide) return;
	requestAnimationFrame(this.hide.bind(this));
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (!this.preventReveal) {
	requestAnimationFrame(this.reveal.bind(this));
	}else {
	window.clearTimeout(this.isScrolling);

	this.isScrolling = setTimeout(() => {
	this.preventReveal = false;
	}, 66);

	requestAnimationFrame(this.hide.bind(this));
	}
	} else if (scrollTop <= this.headerBounds.top) {
	requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	this.closeMenuDisclosure();
	}

	reveal() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
		}
		
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moving-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moving-announcement-bar')) {
    customElements.define('moving-announcement-bar', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected || this.abort) return;
        this.viewport = this.querySelector('.mab__viewport');
        this.track = this.querySelector('.mab__track');
        this.original = this.querySelector('[data-original]');
        this.pauseButton = this.querySelector('.mab__pause');
        if (!this.original || !this.viewport) return;

        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.editor = Boolean(window.Shopify && window.Shopify.designMode);
        this.userPaused = false;
        this.hovered = this.matches(':hover') && matchMedia('(hover: hover)').matches;
        this.keyboardFocus = false;
        this.editing = false;
        this.onScreen = true;
        this.storageKey = `mab:${this.dataset.sectionId}:${this.dataset.dismissKey}`;
        this.restoreDismissal();

        this.pauseButton.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.dataset.userPaused = String(this.userPaused);
          this.pauseButton.setAttribute('aria-label', this.userPaused ? this.dataset.resumeLabel : this.dataset.pauseLabel);
          this.syncPlayback();
        }, { signal });
        this.querySelector('.mab__close')?.addEventListener('click', () => this.dismiss(), { signal });
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch') return;
          this.hovered = true;
          this.syncPlayback();
        }, { signal });
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.syncPlayback();
        }, { signal });

        // Pause on keyboard focus; reveal original links in a wrapping layout.
        this.addEventListener('focusin', (event) => {
          const focusedMessage = event.target.closest('.mab__message');
          if (focusedMessage && !focusedMessage.closest('[data-clone]') && event.target.matches(':focus-visible')) {
            this.keyboardFocus = true;
            this.rebuild();
          }
          this.syncPlayback();
        }, { signal });
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!this.isConnected) return;
            if (!this.contains(document.activeElement) && this.keyboardFocus) {
              this.keyboardFocus = false;
              this.rebuild();
            }
            this.syncPlayback();
          });
        }, { signal });

        this.mobile.addEventListener('change', () => this.schedule(), { signal });
        this.reducedMotion.addEventListener('change', () => this.schedule(), { signal });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), { signal });
        if (this.editor) {
          for (const eventName of ['shopify:section:select', 'shopify:block:select', 'shopify:section:deselect', 'shopify:block:deselect']) {
            document.addEventListener(eventName, (event) => {
              if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
              this.editing = eventName.endsWith(':select');
              this.rebuild();
            }, { signal });
          }
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            const key = `${this.viewport.clientWidth}:${this.original.scrollWidth}`;
            if (key !== this.sizeKey) { this.sizeKey = key; this.schedule(); }
          });
          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.original);
        } else {
          window.addEventListener('resize', () => this.schedule(), { signal });
        }
        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver(([entry]) => {
            this.onScreen = entry.isIntersecting;
            this.syncPlayback();
          });
          this.intersectionObserver.observe(this);
        }
        document.fonts?.ready.then(() => { if (this.isConnected) this.schedule(); });
        this.rebuild();
      }

      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.rebuild());
      }

      rebuild() {
        if (!this.isConnected || !this.track) return;
        this.animation?.cancel();
        this.animation = null;
        this.track.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
        this.classList.remove('is-moving');
        this.pauseButton.hidden = true;

        const shouldMove = this.dataset.motion === 'true'
          && (!this.mobile.matches || this.dataset.mobileMotion === 'true')
          && !this.reducedMotion.matches && !this.keyboardFocus && !this.editing;
        if (!shouldMove || this.hidden || !this.viewport.clientWidth || !this.track.animate) return;
        this.classList.add('is-moving');
        this.pauseButton.hidden = false;
        const distance = this.original.getBoundingClientRect().width;
        if (!distance) {
          this.classList.remove('is-moving');
          this.pauseButton.hidden = true;
          return;
        }

        // One full message group is the repeat unit. Fill even ultrawide screens.
        const copies = Math.ceil(this.viewport.clientWidth / distance) + 1;
        const fragment = document.createDocumentFragment();
        for (let index = 0; index < copies; index++) {
          const clone = this.original.cloneNode(true);
          clone.removeAttribute('data-original');
          clone.dataset.clone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('*').forEach((node) => {
            node.removeAttribute('id');
            node.removeAttribute('data-shopify-editor-block');
            node.removeAttribute('data-message-id');
          });
          clone.querySelectorAll('a, button, [tabindex]').forEach((node) => node.setAttribute('tabindex', '-1'));
          fragment.appendChild(clone);
        }
        this.track.appendChild(fragment);
        const speed = Math.max(5, Number(this.mobile.matches ? this.dataset.mobileSpeed : this.dataset.speed) || 45);
        const frames = [{ transform: 'translate3d(0,0,0)' }, { transform: `translate3d(-${distance}px,0,0)` }];
        if (this.dataset.direction === 'right') frames.reverse();
        this.animation = this.track.animate(frames, { duration: distance / speed * 1000, iterations: Infinity, easing: 'linear' });
        this.sizeKey = `${this.viewport.clientWidth}:${this.original.scrollWidth}`;
        this.syncPlayback();
      }

      syncPlayback() {
        if (!this.animation) return;
        const hoverPause = this.dataset.hoverPause === 'true' && this.hovered;
        const focused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
        if (this.userPaused || hoverPause || focused || document.hidden || !this.onScreen) this.animation.pause();
        else this.animation.play();
      }

      restoreDismissal() {
        if (this.editor || !this.querySelector('.mab__close')) return;
        try {
          if (this.dataset.dismiss === 'session') this.hidden = sessionStorage.getItem(this.storageKey) === '1';
          if (this.dataset.dismiss === 'days') {
            const expiry = Number(localStorage.getItem(this.storageKey));
            this.hidden = expiry > Date.now();
            if (expiry && !this.hidden) localStorage.removeItem(this.storageKey);
          }
        } catch (_) { /* Storage may be unavailable; page-only dismissal still works. */ }
      }

      dismiss() {
        if (this.editor) return; // Keep the section editable in Shopify's preview.
        this.hidden = true;
        this.animation?.cancel();
        try {
          if (this.dataset.dismiss === 'session') sessionStorage.setItem(this.storageKey, '1');
          if (this.dataset.dismiss === 'days') {
            const days = Math.max(1, Number(this.dataset.dismissDays) || 7);
            localStorage.setItem(this.storageKey, String(Date.now() + days * 86400000));
          }
        } catch (_) { /* Dismiss visually even if browser storage is blocked. */ }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.frame);
        this.animation?.cancel();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
